const MD_BREAKPOINT = 744;

export default function initDropdown() {
  const togglers = document.querySelectorAll(".dropdown-toggler");

  if (!togglers.length) return;

  let overlay = null;

  // Track original parent for items moved to body
  const itemOriginal = new Map();

  function getOverlay() {
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.className = "dropdown-overlay";
      document.body.appendChild(overlay);
      overlay.addEventListener("click", closeAll);
    }
    return overlay;
  }

  function closeAll() {
    document.querySelectorAll(".dropdown-item.is-open").forEach((item) => {
      item.classList.remove("is-open");
      item.style.left = "";
      item.style.width = "";

      // Move mega sidebar back to original position
      const original = itemOriginal.get(item);
      if (original) {
        original.parent.insertBefore(item, original.nextSibling);
        itemOriginal.delete(item);
      }
    });
    document.querySelectorAll(".dropdown-toggler.is-active").forEach((t) => {
      t.classList.remove("is-active");
    });
    if (overlay) {
      overlay.classList.remove("is-open");
    }
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }

  function positionMegaDesktop(item) {
    const container = item.closest(".container");
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const containerStyle = getComputedStyle(container);
    const paddingLeft = parseFloat(containerStyle.paddingLeft);
    const paddingRight = parseFloat(containerStyle.paddingRight);

    const contentLeft = containerRect.left + paddingLeft;
    const contentWidth = containerRect.width - paddingLeft - paddingRight;

    const offsetParent = item.offsetParent;
    const parentRect = offsetParent
      ? offsetParent.getBoundingClientRect()
      : { left: 0 };

    item.style.left = `${contentLeft - parentRect.left}px`;
    item.style.width = `${contentWidth}px`;
  }

  function positionRegular(item) {
    item.style.left = "";
    item.style.right = "";

    requestAnimationFrame(() => {
      const itemRect = item.getBoundingClientRect();
      const viewportWidth = document.documentElement.clientWidth;

      if (itemRect.right > viewportWidth) {
        item.style.left = "auto";
        item.style.right = "0";
      }
      if (itemRect.left < 0) {
        item.style.left = "0";
        item.style.right = "auto";
      }
    });
  }

  togglers.forEach((toggler) => {
    const item = toggler.nextElementSibling;
    if (!item || !item.classList.contains("dropdown-item")) return;

    // Ensure parent is positioned for absolute dropdown
    const parent = toggler.parentElement;
    if (parent && getComputedStyle(parent).position === "static") {
      parent.style.position = "relative";
    }

    toggler.addEventListener("click", (e) => {
      e.stopPropagation();

      const isOpen = item.classList.contains("is-open");
      closeAll();

      if (!isOpen) {
        if (window.innerWidth < MD_BREAKPOINT) {
          // Mobile: all dropdowns become sidebar
          itemOriginal.set(item, {
            parent: item.parentElement,
            nextSibling: item.nextElementSibling,
          });
          document.body.appendChild(item);

          // Force reflow before adding is-open for transition
          item.offsetHeight;

          item.classList.add("is-open");
          toggler.classList.add("is-active");

          const scrollbarWidth =
            window.innerWidth - document.documentElement.clientWidth;
          getOverlay().classList.add("is-open");
          document.body.style.overflow = "hidden";
          if (scrollbarWidth > 0) {
            document.body.style.paddingRight = `${scrollbarWidth}px`;
          }
        } else if (item.classList.contains("is-mega")) {
          item.classList.add("is-open");
          toggler.classList.add("is-active");
          positionMegaDesktop(item);
        } else {
          item.classList.add("is-open");
          toggler.classList.add("is-active");
          positionRegular(item);
        }
      }
    });
  });

  // Close button inside dropdown heading
  document.addEventListener("click", (e) => {
    const closeBtn = e.target.closest(".dropdown-close");
    if (closeBtn) {
      e.stopPropagation();
      closeAll();
      return;
    }
  });

  // Close on click outside
  document.addEventListener("click", (e) => {
    if (
      !e.target.closest(".dropdown-toggler") &&
      !e.target.closest(".dropdown-item")
    ) {
      closeAll();
    }
  });

  // Close on Escape
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
  });

  // Close all dropdowns when crossing the md breakpoint
  const mediaQuery = window.matchMedia(`(min-width: ${MD_BREAKPOINT}px)`);
  mediaQuery.addEventListener("change", () => {
    closeAll();
  });

  // Reposition open dropdowns on resize
  window.addEventListener("resize", () => {
    if (window.innerWidth < MD_BREAKPOINT) return;
    document.querySelectorAll(".dropdown-item.is-open").forEach((item) => {
      if (item.classList.contains("is-mega")) {
        positionMegaDesktop(item);
      } else {
        positionRegular(item);
      }
    });
  });
}
